/**
 * Loan Products Page
 * Displays loan products and calculator
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import LoanProductsHero from '../components/LoanProductsHero';
import LoanProductsGrid from '../components/LoanProductsGrid';
import LoanCalculator from '../components/LoanCalculator';

/**
 * Loan Products Page Component
 * @returns {JSX.Element} Loan products page
 */
const LoanProductsPage = () => {
  const [activeTab, setActiveTab] = useState('loans');
  const [selectedLoan, setSelectedLoan] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        element?.scrollIntoView({ behavior: 'auto' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  const handleCalculate = (loan) => {
    setSelectedLoan(loan);
    // Scroll to calculator
    document.getElementById('loan-calculator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="loan-products-page">
      <LoanProductsHero />
      <LoanProductsGrid
        activeTab={activeTab}
        onTabChange={setActiveTab}
        onCalculate={handleCalculate}
      />
      <div id="loan-calculator">
        <LoanCalculator selectedLoan={selectedLoan} />
      </div>
    </div>
  );
};

export default LoanProductsPage;
